module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BoldItalic.8a42d7dd.eot";